module.exports = __webpack_public_path__ + "img/full2-min.211d4c19.png";